import { useCallback, useEffect, useMemo } from 'react'
import ItemFilter from './ItemFilter'
import { useDispatch, useSelector } from 'react-redux'
import { showFilter, updateFilter } from '../../store/actions/filter.actions'
import { useLocation, useNavigate } from 'react-router-dom'
import isEmpty from 'lodash/isEmpty'
import ButtonStartIcon from '../button/ButtonStartIcon'
import { updateSkip } from '../../store/actions/datatable.actions'

const FilterButton = ({ module, keysFilter = [], keepReload = true, disabled = false }) => {
  const moduleState = useSelector((state) => state?.filter?.[module] || {})
  const dispatch = useDispatch()
  const { pathname, state } = useLocation()
  const navigate = useNavigate()

  const onDelete = useCallback(
    (key) => {
      let filter =
        key.indexOf('curriculumElements') !== -1
          ? { ...moduleState?.filter }
          : { ...moduleState?.filter, [key]: '' }

      filter = key.indexOf('curriculumelements') !== -1 ? { ...filter } : { ...filter, [key]: '' }
      if (module === 'audit') {
        if (key === 'user') {
          filter.userId = ''
        }

        if (key === 'role') {
          filter.roles = ''
          filter.roleId = ''
          delete filter.rolesId
          delete filter.roles
        }
        if (key === 'moduleId') {
          filter.action = ''
          filter.actionId = ''
          filter.module = ''
        }
        if (key === 'actionId') {
          filter.action = ''
        }
      }
      if (module === 'user') {
        if (key === 'roles') {
          filter.rolesId = ''
        }
        if (key === 'yearLevel') {
          filter.yearLevelId = ''
        }
        if (key === 'flag') {
          filter.flagId = ''
        }
      }
      if (
        [
          'dataEntryAssessment',
          'dataEntryMyAssessment',
          'dataEntrySurvey',
          'dataEntryMySurvey',
          'assessmentMarking'
        ].includes(module)
      ) {
        if (key === 'template' || key === 'templateId') {
          filter.templateId = ''
          filter.template = ''
        }
        if (key === 'yearLevel' || key === 'yearLevelId') {
          filter.yearLevelId = ''
          filter.yearLevel = ''
        }
        if (key === 'roles' || key === 'rolesId') {
          filter.rolesId = ''
          filter.roles = ''
        }
      }

      if (module === 'builderUsers') {
        if (key === 'roles') {
          filter.rolesId = ''
          filter.roles = ''
        }
        if (key === 'yearLevel') {
          filter.yearLevelId = ''
        }
      }
      if (module === 'assessmentReviewers' || module === 'feed') {
        if (key === 'roles') {
          delete filter.rolesId
          delete filter.roles
        }
        if (key === 'yearLevel') {
          delete filter.yearLevelId
        }
      }

      if (key.indexOf('curriculumElements') !== -1 || key.indexOf('curriculumelements') !== -1) {
        const split = key.split('-').filter((item, i) => i !== 0)
        const code = split.join('.children.')
        const deleteNodeByPath = (obj, path) => {
          const pathParts = path.split('.')
          const currentPath = pathParts.shift()

          if (!obj) {
            // if (!obj || !obj.hasOwnProperty(currentPath)) {
            return // Nodo no encontrado
          }

          if (pathParts.length === 0) {
            delete obj[currentPath] // Eliminar el nodo final
          } else {
            deleteNodeByPath(obj[currentPath], pathParts.join('.'))
          }
        }

        if (key.indexOf('curriculumelements') !== -1) {
          deleteNodeByPath(filter.curriculumelements, code)
        }
        if (key.indexOf('curriculumElements') !== -1) {
          deleteNodeByPath(filter.curriculumElements, code)
        }
      }
      if (['lc', 'subject', 'class', 'learningMatrix'].includes(module)) {
        if (key.indexOf('lcElements') !== -1) {
          const code = key.split('-')[1]
          delete filter.lcElements[code]
          delete filter.lcElements_name[code]
        }
      }
      if (['gantt', 'dr', 'class', 'drGroupedByLearningContinuum', 'learningMatrix'].includes(module)) {
        if (key === 'yearLevel_name' || key === 'yearLevel') {
          filter.yearLevel = ''
          filter.yearLevel_name = ''
        }
        if (key === 'subjectId_name' || key === 'subjectId' || key === 'subject') {
          filter.subjectId = ''
          filter.subject = ''
          filter.subjectId_name = ''
        }
        if (key === 'teachersId' || key === 'teachers') {
          filter.teachers = ''
          filter.teachersId = ''
        }
        if (key === 'classId' || key === 'classes') {
          filter.classes = ''
          filter.classId = ''
        }
        if (key === 'ulId' || key === 'ul' || key === 'unit of learning') {
          filter.ul = ''
          filter.ulId = ''
        }
      }

      if (['periodicalReport'].includes(module)) {
        if (key === 'periodId' || key === 'period') {
          delete filter.periodId
          delete filter.period
        }
      }
      if (['user', 'builderUsers'].includes(module)) {
        if (['activated', 'invited'].includes(key)) {
          delete filter[key]
        }
      }

      dispatch(updateFilter(module, filter))
      dispatch(updateSkip(module, 0))

      if (module === 'builderUsers') {
        dispatch(updateSkip('surveyUsersList', 0))
      } else {
        if (module !== 'assessmentReviewers') {
          navigate(pathname, { state: filter })
        }
      }
    },
    [moduleState, pathname]
  )

  const onOpen = () => {
    dispatch(showFilter(module, true))
  }

  useEffect(() => {
    if (keepReload && !isEmpty(state)) {
      dispatch(updateFilter(module, state))
    }
  }, [state])

  const filterMemo = useMemo(() => {
    return Object.keys(moduleState?.filter || {})
      .filter((key) => {
        const typeOf = typeof moduleState?.filter?.[key]
        if (typeOf === 'string') {
          return moduleState?.filter?.[key] !== ''
        }
        if (typeOf === 'object') {
          const isDatetype = moduleState?.filter?.[key] instanceof Date
          if (isDatetype) {
            return true
          }

          return !isEmpty(moduleState?.filter?.[key])
        }
        if (typeOf === 'boolean') {
          return true
        }
        return true
      })
      .filter((key) => !keysFilter.includes(key))
      .map((key) => ({ key, value: moduleState?.filter?.[key] }))
  }, [moduleState, moduleState?.filter, keysFilter])
  return (
    <>
      <div className='flex items-center gap-2'>
        <ButtonStartIcon
          variant='text'
          startIcon='bars-filter'
          title='Filter'
          onClick={onOpen}
          color='primary'
          classNameIcon='text-3xl'
          size='large'
          disabled={disabled}
        >
          Filter
        </ButtonStartIcon>
        <div className='flex flex-wrap items-center gap-1'>
          {filterMemo.map((filter, i) => (
            <ItemFilter
              key={`filter-${i}-${filter?.key}`}
              code={filter?.key}
              value={filter?.value}
              onDelete={onDelete}
              module={module}
            />
          ))}
        </div>
      </div>
    </>
  )
}
export default FilterButton
